import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Tailwind className merger (shared by web + admin + web-ui). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
